module.exports = __webpack_public_path__ + "static/alisha-9f6e3ee454a30bd3fdc479d5d8c3b21b.png";